import { Link, Navigate } from 'react-router-dom';

import { accueilPourRole, useAuth } from './AuthContext';

/**
 * Site vitrine — formulaire de contact (demande de compte tuteur, onboarding humain).
 *
 * Pointait sur `gray-water-0ed0ac00f.7.azurestaticapps.net/#partenaires`, soit
 * l'ancienne vitrine hébergée sur la Static Web App `swa-silex-site`, que le
 * fondateur a décidé d'éteindre le 1er octobre 2026. La section « Partenaires »
 * n'existe pas sur le site Wix : son équivalent est le formulaire de contact de
 * la page Tarifs, juste sous le bloc « École, agence de tutorat, organisme
 * d'aide aux devoirs ». C'est bien là qu'un tuteur sans compte doit arriver.
 *
 * L'adresse de marque, et non `neth.ca` : `www.silexeducation.ca` redirige
 * aujourd'hui en 301 vers l'hôte Wix EN CONSERVANT le chemin (vérifié le
 * 1er octobre 2026), donc ce lien marche déjà — et il restera juste après la
 * bascule du domaine, sans qu'on ait à repasser ici.
 */
const CONTACT_VITRINE_URL = 'https://www.silexeducation.ca/tarifs#contact';

/**
 * Page d'accueil de la console (`/`).
 *
 * SLX-116 — LA PORTE. Cette page n'offre plus qu'UNE connexion, celle du
 * tuteur. Le bloc « Je suis parent → Se connecter » a été retiré : il menait
 * une famille jusqu'à une authentification réussie, puis à un refus. C'est le
 * pire des deux mondes, et c'est exactement ce que le document de conception
 * arbitre (EXPERIENCE-PARENT-TUTEUR §4.3 : « retirer l'option "Je suis parent"
 * de la page d'accueil web »).
 *
 * Le parent n'est pas ignoré pour autant : il lit ici, AVANT toute saisie, où
 * se trouve son espace. Un parent qui se connecterait quand même (marque-page,
 * identifiants tapés directement sur `/login`) est reçu par `RequireAuth` avec
 * la même orientation, jamais par un mur.
 *
 * Aucune logique de rôle côté client : le rôle réel vient toujours du serveur
 * après connexion. Un utilisateur déjà connecté est renvoyé vers son écran
 * d'accueil (`/ma-journee`, ou `/administration` pour un admin) — même patron
 * que `LoginScreen`.
 */
export function WelcomePage() {
  const { status, user } = useAuth();

  if (status === 'authenticated' && user) {
    return <Navigate to={accueilPourRole(user.role)} replace />;
  }

  return (
    <div className="auth-screen">
      <div className="welcome-card">
        <div className="auth-card__brand">
          Silex
          <span className="brand-dot" aria-hidden="true" />
        </div>
        <p className="form-note">Console tuteur et administration.</p>

        <div className="welcome-choices">
          <div className="role-card">
            <Link to="/login" className="role-card__link">
              <h3 className="role-card__title">Je suis tuteur</h3>
              <span className="role-card__cta">Se connecter →</span>
            </Link>
            <p className="role-card__hint">
              Pas encore de compte tuteur&nbsp;?{' '}
              <a href={CONTACT_VITRINE_URL} target="_blank" rel="noopener noreferrer">
                Écrivez-nous.
              </a>
            </p>
          </div>

          <div className="role-card role-card--info">
            <h3 className="role-card__title">Vous êtes parent&nbsp;?</h3>
            <p className="role-card__hint">
              Le suivi de votre enfant est dans l'application Silex. Aucun compte web à créer ici.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
